import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { I18nService } from '@app/i18n/services';
import { FeedbackData, FeedbackService, FeedbackStyle, FeedbackTitle } from '@services/feedback';
import { ProgressIndicatorService } from '@services/progress';
import { UsersService } from '../../../../../../services/users';
import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';

import { IVerifyEmailDialogData } from './users-verify-email.models';

@Component({
	selector: 'app-users-verify-email',
	templateUrl: './users-verify-email.dialog.html'
})
export class UsersVerifyEmailDialogComponent extends OnDestroyMixin {
	private i18nConfirmVerifyEmailAction = this.i18nService.get(
		'Are you sure you want to manually verify this email address?',
		'app.prompt.users.verify-email.confirm-message'
	);

	constructor(
		private i18nService: I18nService,
		private feedbackService: FeedbackService,
		private usersService: UsersService,
		private progressIndicatorService: ProgressIndicatorService,
		@Inject(MAT_DIALOG_DATA) public dialogData: IVerifyEmailDialogData,
		private dialogRef: MatDialogRef<UsersVerifyEmailDialogComponent>
	) {
		super();
	}

	onFormSubmit() {
		const data: FeedbackData = {
			title: FeedbackTitle.warning,
			message: this.i18nConfirmVerifyEmailAction,
			style: FeedbackStyle.error,
			callback: (confirmed: boolean) => {
				if (confirmed) {
					this.toggleEmailVerification();
				} else {
					this.dialogRef.close();
				}
			}
		};

		this.feedbackService.confirm(data);
	}

	private toggleEmailVerification() {
		this.progressIndicatorService.spinner(true);

		this.usersService
			.setEmailVerification(
				this.dialogData.user.id,
				this.dialogData.user.email
			)
			.subscribe(
				() => {
					this.progressIndicatorService.spinner(false);
					this.dialogData.callback(this.dialogData.user);
					this.feedbackService.notification({
						msg: this.i18nService.get('Email address verified.', 'app.descriptor.users.email-verified'),
						config: { duration: 4000 }
					});
					this.dialogRef.close();
				},
				(error: any) => {
					this.feedbackService.apiError(error);
					this.progressIndicatorService.spinner(false);
				}
			);
	}
}
